<template>
    <div class="header">
        <div class="menu">
            <div class="logo">
                <router-link to="/">
                    <img src="../assets/images/logo.svg" alt="logo" style="width:100%">
                </router-link>
            </div>
            <!--PC用ヘッダー-->
            <div class="pc">
                <div class="buttons">
                    <div class="search_conditions">
                        <div class="search_box">
                            <p><label for="search_pc">品番で検索</label></p>
                            <SearchInput/>
                        </div>
                        <div class="search_pull_downs">
                            <SearchPullDowns/>
                        </div>
                        <div class="selected_tags">
                            <div class="tag_icon" v-if="search_conditions.length">
                                <img src="../assets/images/tag_icon.svg" alt="tag_icon">
                            </div>
                            <div class="tag" v-for="tag in search_conditions" :key="tag.id">
                                <SelectedTag :tag="tag"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <a :href="login_url" class="login_button">
                        <LoginButton/>
                    </a>
                    </div>
                </div>
            </div>
            <!--PC用すきカモリストボタン-->
            <div class="pc">
                <div v-if="user_data.id === -1" style="cursor: pointer" @click="$modal.show('login_modal')">
                    <div class="sukikamo_list">
                        <div class="sukikamo_list_msg"><img src="../assets/images/list_msg.svg" alt="すきカモリスト"></div>
                        <div class="sukikamo_list_sugata"><img src="../assets/images/list_sukikamo.svg" alt="すきカモ"></div>
                        <div class="sukikamo_list_hukidashi">
                            <img class="slideshow" src="../assets/images/list_kamo_hukidashi_text.svg" alt="すきカモ吹き出し01">
                            <img class="slideshow fadeout" src="../assets/images/test2.svg" alt="すきカモ吹き出し02">
                            <img class="slideshow fadeout" src="../assets/images/test3.svg" alt="すきカモ吹き出し03">
                            <img  class="slideshow fadeout" src="../assets/images/test4.svg" alt="すきカモ吹き出し04">
                        </div>
                    </div>
                </div>
                <router-link to="/mypage" v-else>
                    <div class="sukikamo_list">
                        <div class="sukikamo_list_msg"><img src="../assets/images/list_msg.svg" alt="すきカモリスト"></div>
                        <div class="sukikamo_list_sugata"><img src="../assets/images/list_sukikamo.svg" alt="すきカモ"></div>
                        <div class="sukikamo_list_hukidashi">
                            <img class="slideshow" src="../assets/images/list_kamo_hukidashi_text.svg" alt="すきカモ吹き出し01">
                            <img class="slideshow fadeout" src="../assets/images/test2.svg" alt="すきカモ吹き出し02">
                            <img class="slideshow fadeout" src="../assets/images/test3.svg" alt="すきカモ吹き出し03">
                            <img  class="slideshow fadeout" src="../assets/images/test4.svg" alt="すきカモ吹き出し04">
                        </div>
                    </div>
                </router-link>
            </div>
            <!--SP用ヘッダー-->
            <div class="sp">
                <div class="sukikamo_list_sp">
                    <div v-if="user_data.id === -1" style="cursor: pointer" @click="$modal.show('login_modal')">
                        <img src="../assets/images/list_msg_sp.svg" alt="すきカモリスト">
                    </div>
                    <router-link to="/mypage" v-else>
                        <img src="../assets/images/list_msg_sp.svg" alt="すきカモリスト">
                    </router-link>
                    <div class="buttons">
                        <a :href="login_url"><LoginButton/></a>
                    </div>
                </div>
            </div>
        </div>
        <!--SP用ヘッダー-->
        <div class="sp">
            <div v-if="search_conditions.length">
                <div class="selected_tags">
                    <div class="tag_icon">
                        <img src="../assets/images/tag_icon.svg" alt="tag_icon">
                    </div>
                    <div class="tag" v-for="tag in search_conditions" :key="tag.id">
                        <SelectedTag :tag="tag"/>
                    </div>
                </div>
            </div>
        </div>

        <modal name="login_modal"  :maxWidth="600" width="90%" :adaptive="true">
            <div class="caution">お気に入り機能をご利用いただくには<br class="sp">ログインが必要です。</div>
        </modal>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import SearchPullDowns from './SearchPullDowns'
    import LoginButton from './LoginButton'
    import SelectedTag from './SelectedTag'
    import AppPath from '../assets/js/AppPath'
    import SearchInput from './SearchInput'

    export default {
        name: "Header",
        components: { SearchPullDowns, LoginButton, SelectedTag, SearchInput },
        data: () => ({
            index: 0,
            timer_id: 0,
            login_url: AppPath.login
        }),
        computed: {
            ...mapState(["user_data"]),
            ...mapState('search', ['search_conditions']),
        },

        mounted() {
            const images = document.getElementsByClassName('slideshow');
            this.slideshow(images);
            // this.timer_id = setInterval(() => {
            //     this.index = this.index < images.length - 1 ? this.index + 1 : 0;
            //     this.slideshow(images);
            // }, 4000);
            return;
        },
        destroyed() {
            if ( this.timer_id ) clearInterval(this.timer_id);
        },
        methods: {
            slideshow(images) {
                const current = images[this.index];
                const prev = images[this.index - 1] ? images[this.index - 1] : images[images.length - 1];
                current.classList.add('fadein');
                current.classList.remove('fadeout');
                prev.classList.remove('fadein');
                prev.classList.add('fadeout');
            }
        }
    }
</script>

<style scoped lang="scss">
    .caution{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header{
        padding: 2rem 0;
        background-color: white;

        .menu{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 90vw;
            max-width: 1280px;
            min-width: 1020px;
            margin: auto;
            .logo{
                width: 300px;
                margin-right: 10px;
            }
            .buttons{
                position: relative;
                top: 0;
                display: flex;
                .search_conditions{
                    // position: relative;
                    // width: 550px;
                    .search_box {
                        position: relative;
                        p {
                            font-size: 15px;
                            color: #826E67;
                            margin: 0;
                        };
                    }
                    .search_pull_downs{
                    }
                    .selected_tags{
                        position: absolute;
                        bottom: -10px;
                        transform: translateY(50%);
                        display: flex;
                        align-items: center;
                        .tag_icon{
                            user-select: none;
                            width: 13px;
                            margin-right: 0.5rem;
                            img{
                                vertical-align: middle;
                            }
                        }
                        .tag:not(:last-child){
                            margin-right: 1rem;
                        }
                    }
                }
                .login_button {
                    // display: flex;
                    // align-items: center;
                    position: relative;
                    top: 61px;
                }
            }
        }
        .sukikamo_list {
            display: flex;
            height: 130px;
            margin: 10px 0 auto;
        }
        .sukikamo_list_msg {
            max-width: 68px;
            min-width: 58px;
            margin: auto 10px 15px;
            img{
                width: 100%;
            }
        }
        .sukikamo_list_sugata {
            max-width: 74px;
            min-width: 64px;
            margin: auto 10px 0;
            img{
                width: 100%;
            }
        }
        .sukikamo_list_hukidashi {
            max-width: 138px;
            min-width: 128px;
            margin: 0;
            img{
                width: 100%;
            }
            .fadein {
                opacity: 1;
                transition: opacity;
                width: 100%;
                max-width: 138px;
                min-width: 128px;
            }
            .fadeout {
                opacity: 0;
                transition: opacity;
                width: 100%;
                max-width: 138px;
                min-width: 128px;
            }
            .slideshow {
                position: absolute;
            }
        }
    }

    @media screen and (max-width:639px) {
        .header {
            width: 100%;
            padding: 2px 10px 0;
            box-sizing: border-box;
            position: fixed;
            box-shadow: initial;
            z-index: 20;
            .menu{
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                .buttons {
                    position: relative;
                    top: 0;
                    display: flex;
                    .login_button {
                        top: 0;
                    }
                }
                .logo{
                    width: 95px;
                }
            }
            .selected_tags{
                position: absolute;
                left: 0;
                bottom: -40px;
                transform: initial;
                display: flex;
                height: 40px;
                padding: 8px 0 8px 10px;
                box-sizing: border-box;
                align-items: center;
                width: 100%;
                background-color: #f2f2f2;
                .tag_icon{
                    width: 11px;
                    margin-right: 0.5rem;
                    img{
                        vertical-align: middle;
                    }
                }
            }
            .sukikamo_list_sp {
                display: flex;
                img {
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
        }
    }
</style>
